/**
 * Input-modality tracker. Flags keyboard vs pointer focus on
 * `<html data-ui-modality="keyboard|pointer">` so the focus ring defined in
 * `tokens.css` (`[data-slot=...]:focus-visible { outline: ... }` suppressed by
 * `[data-ui-modality="pointer"]`) shows only during keyboard navigation.
 *
 * Why it's needed: text inputs match `:focus-visible` on mouse click too, so CSS
 * alone can't tell a click apart from a Tab. This mirrors the design system's own
 * tracker (referenced by the `tokens.css` form-control block). Idempotent: the
 * window guard attaches the listeners once even though several form components
 * import this module for its side effect.
 */
declare global {
  interface Window {
    __dsUiModality?: boolean;
  }
}

if (typeof window !== 'undefined' && !window.__dsUiModality) {
  window.__dsUiModality = true;
  const root = document.documentElement;
  const set = (modality: 'keyboard' | 'pointer') => root.setAttribute('data-ui-modality', modality);
  window.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Tab') {
        set('keyboard');
      }
    },
    true,
  );
  window.addEventListener('pointerdown', () => set('pointer'), true);
}

export {};
